import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, TextArea } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import style from './supportchat.module.scss';

const parseMarkdown = (str) =>
  str
    .replace(/^### (.*$)/gim, '<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '<h1>$1</h1>')
    .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
    .replace(/\*(.*)\*/gim, '<em>$1</em>')
    .replace(/!\[(.*?)\]\((.*?)\)/g, '<img alt="$1" src="$2" />')
    .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>')
    .replace(/\n/g, '<br />');

const Message = ({ isIncoming, text, date, isPreloader, ...props }) => (
  <div
    className={`${style.message} ${isIncoming ? style.incomingMessage : ''}`}
    {...props}
  >
    <div className={style.avatar}>
      <img
        src={isIncoming ? '/images/DaVinchi.png' : '/images/defolt-user.svg'}
        alt=""
      />
    </div>
    <div>
      <p className={style.messageAuthor}>{isIncoming ? 'ДаВинчи' : 'Вы'}</p>

      {isPreloader && isIncoming ? (
        <div className={`${style.messageText} ${style.isPreloader}`}>
          Печатает...
        </div>
      ) : (
        <div
          className={style.messageText}
          dangerouslySetInnerHTML={{
            __html: parseMarkdown(text)
          }}
        />
      )}
    </div>
  </div>
);

const SupportChat = ({ visible, setVisible }) => {
  const [messagesData, setMessagesData] = useState([
    {
      id: Date.now(),
      text: `Здравствуйте! Я мультиагентная система поддержки MES ДаВинчи.
      \n \n Задайте ваш вопрос!`,
      isIncoming: true,
      date: `${new Date().getHours()}:${new Date().getMinutes()}`
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesWindowRef = useRef(null);

  const [controller, setController] = useState(new AbortController());

  const scrollToBottom = () => {
    if (messagesWindowRef.current) {
      const messageElements = messagesWindowRef.current.children;
      const lastMessageElement = messageElements[messageElements.length - 1];

      // eslint-disable-next-line no-unused-expressions
      lastMessageElement
        && lastMessageElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messagesData]);

  const addMessage = useCallback(() => {
    const currentMessage = {
      id: Date.now(),
      text: inputValue,
      isIncoming: false,
      date: `${new Date().getHours()}:${new Date().getMinutes()}`
    };

    const preloaderMessage = {
      id: Date.now() + 1,
      text: 'Печатает...',
      isIncoming: true,
      date: `${new Date().getHours()}:${new Date().getMinutes()}`,
      isPreloader: true
    };

    if (inputValue.trim()) {
      setMessagesData((prev) => [...prev, currentMessage, preloaderMessage]);
      setInputValue('');
      setIsLoading(true);
    }

    const newController = new AbortController();
    setController(newController);
    const signal = newController.signal;

    fetch('http://127.0.0.1:5000/chat', {
      method: 'POST',
      signal,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify({ message: inputValue })
    })
      .then((r) => r.json())
      .then((r) => {
        const incomingMessage = {
          id: Date.now(),
          text: r.message,
          isIncoming: true,
          date: `${new Date().getHours()}:${new Date().getMinutes()}`
        };
        setMessagesData((prev) => [
          ...prev.slice(0, prev.length - 1),
          incomingMessage
        ]);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }, [inputValue]);

  const renderMessages = useMemo(
    () =>
      messagesData.map(({ id, text, isIncoming, date, isPreloader }) => (
        <Message
          key={id}
          text={text}
          isIncoming={isIncoming}
          date={date}
          isPreloader={isPreloader}
        />
      )),
    [messagesData]
  );

  const onQuickReplyClick = useCallback((e) => {
    setInputValue(e.element.innerText);
  }, []);

  const resetChat = useCallback(() => {
    if (controller) {
      controller.abort();
    }

    fetch('http://localhost:5000/reset', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then((_) => {
        alert('Чат сброшен');
        setMessagesData((prev) => prev.slice(0, 1));
        controller.abort();
      })
      .catch((error) => console.log(error));
  }, [controller]);
  return (
    <Popup
      height="95%"
      width="35%"
      position="right top"
      visible={visible}
      shading={false}
      showTitle={false}
      onHiding={() => setVisible(false)}
      className={style.SupportChatPopup}
    >
      <div className={style.SupportChat}>
        <div className={style.header}>
          <span>Напишите ваше сообщение</span>
          <Button icon="close" onClick={() => setVisible(false)} />
        </div>
        <ScrollView direction="vertical" scrollByThumb>
          <div className={style.messages} ref={messagesWindowRef}>
            {renderMessages}
          </div>
        </ScrollView>

        <div className={style.inputBlock}>
          {messagesData.length <= 1 && (
            <div className={style.quickReplies}>
              <Button
                className={style.quickReply}
                onClick={onQuickReplyClick}
                stylingMode="outlined"
              >
                тест тест
              </Button>
              <Button
                className={style.quickReply}
                onClick={onQuickReplyClick}
                stylingMode="outlined"
              >
                тест тест тест тест тест
              </Button>
              <Button
                className={style.quickReply}
                onClick={onQuickReplyClick}
                stylingMode="outlined"
              >
                тест
              </Button>
            </div>
          )}
          <TextArea
            placeholder="Введите сообщение"
            className={style.input}
            value={inputValue}
            onValueChanged={({ value }) => setInputValue(value)}
            valueChangeEvent="input"
          />
          <Button
            type="default"
            stylingMode="contained"
            icon="arrowup"
            className={style.sendBtn}
            onClick={addMessage}
            disabled={!inputValue.trim() || isLoading}
          />

          {messagesData.length >= 2 && (
            <Button type="default" className={style.resetBtn} onClick={resetChat}>
              Сброс
            </Button>
          )}
        </div>
      </div>
    </Popup>
  );
};

export default SupportChat;
